<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ announcement ? 'Update Announcement' : 'Add Announcement' }}
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Title*">
          <d-input v-model="announcementForm.title" :required="true" />
        </d-field>
        <div class="flex flex-wrap -mx-5">
          <d-field label="Start Showing Date" class="w-full md:w-1/2 px-5">
            <d-datepicker v-model="announcementForm.startShowingDate" icon="calendar" expanded />
          </d-field>
          <d-field label="End Showing Date" class="w-full md:w-1/2 px-5">
            <d-datepicker v-model="announcementForm.endShowingDate" icon="calendar" expanded />
          </d-field>
        </div>
        <d-field label="Content*">
          <vue-editor v-model="announcementForm.html" :required="true" :editor-toolbar="customToolbar" />
        </d-field>

        <permission-selector ref="permissionSelector" :key="entityId" :entity-id="entityId" entity-type="Announcement" />
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn
          :loading="saving"
          type="submit"
        >
          {{ announcement ? 'Update Announcement' : 'Add Announcement' }}
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      announcement: {
        type: Object,
        default: () => {},
      },
      userId: {
        type: String,
        default: () => '',
      },
    },

    data: () => ({
      data: [],
      saving: false,
      isFetching: false,
      announcementForm: {
        title: '',
        html: '',
        startShowingDate: null,
        endShowingDate: null,
        userId: 0,
      },
      entityId: 0,
      customToolbar: [
        [{ header: [false, 3, 4, 5, 6] }], ['bold', 'italic', 'underline', 'strike'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['blockquote', 'code-block'],
        [{ indent: '-1' }, { indent: '+1' }], [{ color: [] }, { background: [] }], ['clean'],
        ['link'],
      ],
    }),

    mounted() {
      if (this.announcement) {
        this.announcementForm = JSON.parse(JSON.stringify(this.announcement));
        this.entityId = this.announcementForm.id;
      }
      this.announcementForm.userId = this.userId;
    },

    methods: {
      async saveForm() {
        if (!this.announcementForm.endShowingDate) {
          this.$toast.error('End showing date is required');
          return;
        }
        this.saving = true;
        try {
          if (this.announcement) {
            const { data } = await axios.patch(
              `/api/admin/announcements/${this.announcementForm.id}`,
              this.announcementForm,
            );
            await this.$refs.permissionSelector.saveData(this.announcementForm.id);
          } else {
            const { data } = await axios.post('/api/admin/announcements/', this.announcementForm);
            await this.$refs.permissionSelector.saveData(data.id);
          }

          this.$toast.success('Save successful!');
          await this.$parent.events.getAnnouncementsPaged();
          this.$parent.close();
        } catch (error) {
          this.$toast.error(error.message.data);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>